import { Edit, Visibility } from "@mui/icons-material";
import { Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import Datatable from "app/partials/datatable/Datatable";
import moment from "moment";
import { FC } from "react";
import useMiniScentModel, { MiniScentDevice } from "./useMiniScentModel";
import { Link } from "react-router-dom";

const MiniScentView: FC<ReturnType<typeof useMiniScentModel>> = ({
  translate,
  miniScentDevices,
  setMiniScentDevices,
  reload,
  getDeviceStatus,
  getStatusColor,
  getStatusLabel,
}) => {
  const headRows = [
    {
      key: 1,
      column: "",
      label: "Ações", // translate("screens.dashboard.action")
      width: 80,
    },
    {
      key: 2,
      column: "SerialNumber",
      label: "Número de Série", // translate("screens.device.labels.serialNumber")
    },
    {
      key: 3,
      column: "Name",
      label: "Nome", // translate("screens.device.labels.name")
    },
    {
      key: 4,
      column: "Status",
      label: "Status", // translate("screens.device.labels.status")
      width: 120,
    },
    {
      key: 5,
      column: "UpdatedAt",
      label: "Última Atualização", // translate("screens.quiz.list.updated")
    },
  ];

  const formatRow = (r: MiniScentDevice) => {
    const status = getDeviceStatus(r.deletedAt);

    return (
      <TableRow hover tabIndex={-1} key={r.miniscentDeviceId}>
        <TableCell scope="row">
          <Link
            to={{
              pathname: `/admin/miniscent/devices/${r.serialNumber}`,
            }}
          >
            <Tooltip title="Ver Detalhes">
              {/* translate("buttons.viewDetails") */}
              <IconButton
                size="small"
                sx={{
                  "&:hover": {
                    backgroundColor: "primary.light",
                    color: "primary.contrastText",
                  },
                }}
              >
                <Visibility fontSize="small" />
              </IconButton>
            </Tooltip>
          </Link>
        </TableCell>
        <TableCell scope="row">
          <strong>{r.serialNumber}</strong>
        </TableCell>
        <TableCell scope="row">{r.name || "-"}</TableCell>
        <TableCell scope="row">
          <Chip
            label={getStatusLabel(status, translate)}
            color={getStatusColor(status)}
            size="small"
            sx={{ fontWeight: 500 }}
          />
        </TableCell>
        <TableCell scope="row">
          {moment(r.updatedAt).format("DD/MM/YYYY HH:mm")}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Datatable
      title={"Dispositivos MiniScent"}
      endpoint="/miniscent/devices"
      headRows={headRows.sort((a, b) => a.key - b.key)}
      formatRow={formatRow}
      rows={miniScentDevices}
      setRows={setMiniScentDevices}
      reload={reload}
      disableStatus={true}
      placeholderSearch={"Buscar dispositivo..."}
    />
  );
};

export default MiniScentView;
